@let label = labelSg();

<div class="atn-ds-input-field">
  @if (label) {
    <span class="atn-ds-input-field__label"> {{ label }} </span>
  }
  <textarea
    class="atn-ds-input-field__control"
    type="text"
    [(ngModel)]="valueSg"
    [disabled]="!!disabledSg()"
    [placeholder]="placeholderSg()"
    [readOnly]="readonlySg()"
    [style.height]="styleOverridesSg()?.height"
    [style.backgroundColor]="styleOverridesSg()?.backgroundColor"
    [style.resize]="styleOverridesSg()?.resize"
    (change)="onChangeHandler($event)"
    (keydown.enter)="onEnterHandler($event)"
  ></textarea>
</div>
